"use client";

import { toast, ToastOptions } from "react-toastify";
import { useTheme } from "next-themes";
import "react-toastify/dist/ReactToastify.css";

type ToastType = "info" | "success" | "warning" | "error";

const useToast = () => {
  const { resolvedTheme } = useTheme();

  const showToast = (
    message: string,
    type: ToastType = "info",
    options?: ToastOptions
  ) => {
    toast[type](message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: resolvedTheme === "dark" ? "dark" : "light",
      ...options,
    });
  };

  return { showToast };
};

export { useToast };
